/* jscs:disable disallowFunctionDeclarations*/
(function(){
  'use strict';

  angular.module('AcaApp').controller('CorrectionController', CorrectionController);

  CorrectionController.$inject = [
    '$rootScope',
    '$scope',
    '$mdDialog',
    '$window',
    '$http',
    'SendService',
    'UtilsService',
    'EmployerService',
    'CORRECTIONS_PAGE',
    'CorrectionService',
    'ReportService',
    'ParticipantService',
    'FormService',
    '$routeParams',
    'OUTPUT_TYPE',
    'SETTINGS',
    'AuxiliaryOperationsService',
    '$window',
    '$interval',
    'ShortcutsService',
    'XMIT_STATUS',
    'CheckListService',
    'PARTICIPANT_FORM',
    'ManagedUserInformationService',
    'LRJ_MANAGER',
    'ERROR',
    '$route',
    '$location',
    'CommonTransmittalService'
  ];

  function CorrectionController(
    $rootScope,
    $scope,
    mdDialog,
    window,
    http,
    sendService,
    utilsService,
    employerService,
    CORRECTIONS_PAGE,
    correctionService,
    reportService,
    participantService,
    formService,
    $routeParams,
    OUTPUT_TYPE,
    SETTINGS,
    AuxiliaryOperationsService,
    $window,
    $interval,
    ShortcutsService,
    XMIT_STATUS,
    checkListService,
    PARTICIPANT_FORM,
    ManagedUserInformationService,
    LRJ_MANAGER,
    ERROR,
    $route,
    $location,
    CommonTransmittalService){
    var _this = this;

    /** properties */
    _this.correctionsPage = '';
    _this.errorReports = [];
    _this.family = [];
    _this.employer = {};
    _this.errorReportSubscribers = [];
    _this.errorReportsEmployers = [];
    _this.tinWithMask = '';
    _this.accountnoEmployer = '';
    _this.selectedXmitRun = '';
    _this.token = '';
    _this.filename = '';
    _this.shortfilename = '';
    _this.descriptionError = '';
    _this.currentEntity = {};
    _this.retransmit = {};
    _this.employers = [];
    _this.errorMessage = '';
    _this.form = [];
    _this.employersSelected = false;
    _this.formsSelected = false;
    _this.fileParts = [];
    _this.showfilename = '';
    _this.xmitRun = '';
    _this.employerRecords = [];
    _this.jobProcessing = false;
    _this.errorMessageXmit = '';
    _this.outputType = OUTPUT_TYPE.TRANSMITTAL.toLowerCase();
    _this.listPayers = [];
    _this.taxYear = window.sessionStorage.taxYear;
    _this.comesCheckList = false;
    _this.configuration = {};

    /** methods */
    _this.errorReportByXmit = _errorReportByXmit;
    _this.showPopupEmployers = _showPopupEmployers;
    _this.goBackToCorrectionReport = _goBackToCorrectionReport;
    _this.openMsgRecordContains = _openMsgRecordContains;
    _this.back = _back;
    _this.backSend = _backSend;
    _this.openParticipant = _openParticipant;
    _this.goEmployerErrorPage = _goEmployerErrorPage;
    _this.openEmployerInformationEdit = _openEmployerInformationEdit;
    _this.openEditFormC = _openEditFormC;
    _this.generateReport = _generateReport;
    _this.goFamily = _goFamily;
    _this.openMsgChangesFixed = _openMsgChangesFixed;
    _this.openForm1095 = _openForm1095;
    _this.getTinMask = _getTinMask;
    _this.markAsReady = _markAsReady;
    _this.retrasmitCorrected = _retrasmitCorrected;
    _this.retransmitConfirmation = _retransmitConfirmation;
    _this.retransmitConfirmationDocGen = _retransmitConfirmationDocGen;
    _this.sendReXmit = _sendReXmit;
    _this.cancelTransmitCorrected = _cancelTransmitCorrected;
    _this.setReviewStatusOnReport = _setReviewStatusOnReport;
    _this.closeModal = _closeModal;
    _this.goToCorrectionPage = _goToCorrectionPage;
    _this.goSend = _goSend;
    _this.generateTransmittal = _generateTransmittal;
    _this.checkProfileToShow = _checkProfileToShow;
    _this.isManagedServices = _isManagedServices;
    _this.showEmailAddress = _showEmailAddress;
    _this.getTotal = _getTotal;
    _this.filesWithXmitrun = [];
    _this.filesNames = [];

    _activate();

    /**
     * @private
     * @description Initialize the controller data.
     */
    function _activate(){
      _routeToSection();
    }

    function _getTotal(){
      var total = 0;
      _.each(_this.employerRecords, function(employer){
        total += totals(employer);
      });
      return total;
    };

    var totals = function(employer){
      return (_this.outputType == OUTPUT_TYPE.PRINTSERVICE.toLowerCase()) ? employer.FormCount : employer.SubscriberCount;
    };

    /** @private */
    function _setIrsError(data){
      data.result.forEach(function(element){
        element.xmitdate = utilsService.reformatDateString(element.xmitdate);
        element.errordate = utilsService.reformatDateString(element.errordate);
        if(element.employers) {
          if(element.employers.length > 2){
            element.amountEmployers = element.employers.length - 2;
            element.showOthers = true;
          }
          else{
            element.amountEmployers = element.employers.length;
            element.showOthers = false;
          }
          element.employers.forEach(function(el){
            el.fullName = _getName(el.Pname) + ' ' + _getName(el.Pname2);
          });
        }
      });

      _this.errorReports = data.result;
    }

    /** @private */
    function _routeToSection(){
      var section = $routeParams.section;
      var data = $routeParams.data || {};
      switch(section){
        case CORRECTIONS_PAGE.CORRECTIONS_REPORT:
          _errorReportByXmit(data);
          break;
        case CORRECTIONS_PAGE.RETRANSMIT_CORRECTED:
          _this.comesCheckList = true;
          _getEmployers1095Corrected();
          _retrasmitCorrected();
          break;
        default:
          _this.correctionsPage = CORRECTIONS_PAGE.CORRECTIONS;
          sendService.getIrsErrorReports().then(_setIrsError);
          break;
      }
    }

    function _getEmployers1095Corrected(){
      checkListService.getEmployers1095Correct().then(function(data){
        data.forEach(function(el){
          el.payerid = el.ptin;
        });
        _this.employers = data;
      });
    }

    /** @public */
    function _errorReportByXmit(xmitrun){
      _this.errorReportSubscribers = [];
      _this.errorReportsEmployers = [];
      _this.selectedXmitRun = xmitrun;
      correctionService.getCorrectionRecords(xmitrun).then(function(data){
        _this.correctionsPage = CORRECTIONS_PAGE.CORRECTIONS_REPORT;
        data.result.map(function(e){
          switch(e.form){
            case 'PAYER':
              e.tinWithMask = participantService.maskTin(e.pein);
              e.tinWithoutSuffix = participantService.removeSuffixOnTin(e.pein);
              _this.errorReportsEmployers.push(e);
              break;
            case '1095-B':
            case '1095-C':
              e.tinWithMask = participantService.maskTin(e.tin);
              e.tinWithoutSuffix = participantService.removeSuffixOnTin(e.tin);
              _this.errorReportSubscribers.push(e);
              break;
          }
        });
      });
    }

    /** @public */
    function _showPopupEmployers(action, xmitrun){
      $(xmitrun)[action]('slow');
    }

    /** @public */
    function _goBackToCorrectionReport(){
      if(_this.currentEntity.ready_to_resubmit === 'Uncorrected'){
        var confirm = mdDialog.confirm({
          templateUrl: 'app/views/corrections/modals/messageMarkingAsCorrected.html',
          parent: angular.element(document.body),
          controller: 'DialogController'
        });
        mdDialog.show(confirm).then(function(){
          _this.errorReportByXmit(_this.selectedXmitRun);
        });
      }
      else{
        _this.correctionsPage = CORRECTIONS_PAGE.CORRECTIONS_REPORT;
      }
    }

    /** @public */
    function _openMsgRecordContains(){
      mdDialog.show({
        scope: $scope.$new(),
        preserveScope: true,
        templateUrl: 'app/views/corrections/modals/messageRecordContains.html',
        parent: angular.element(document.body),
        controller: 'DialogController'
      });
    }

    /** public */
    function _goEmployerErrorPage(employer){
      _this.accountnoEmployer = employer.accountno;
      _this.currentEntity = employer;
      _this.correctionsPage = CORRECTIONS_PAGE.ERROR_EMPLOYER_FORM;
      _this.descriptionError = employer.errorcd + ' - ' + employer.errortxt;
      _this.oldpname = employer.pname;
      _this.oldpein = employer.pein;
      _getEmployer(employer.payerid);
    }

    /** @private */
    function _getEmployer(ptin){
      return employerService.GetEmployerByPk(ptin).then(function(data){
        _this.employer = data.result;
        _this.employer.ready_to_resubmit = _this.currentEntity.ready_to_resubmit;
        _this.employer.form = _this.currentEntity.form;
        _this.employer.path = CORRECTIONS_PAGE.CORRECTIONS;
      });
    }

    /** @public */
    function _openMsgChangesFixed(){
      mdDialog.show({
        scope: $scope.$new(),
        preserveScope: true,
        templateUrl: 'app/views/corrections/modals/messageChangesFixed.html',
        parent: angular.element(document.body),
        controller: 'DialogController'
      });
    }

    /** @public */
    function _openParticipant(index, modrecno){
      participantService.getParticipantByModRecno(modrecno).then(
        function(data){
          _this.family[index].tinWithoutSuffix = data.result.tinWithoutSuffix;
          mdDialog.show({
            scope: $scope.$new(),
            preserveScope: true,
            templateUrl: PARTICIPANT_FORM[utilsService.getTaxYear()],
            parent: angular.element(document.body),
            controller: 'ParticipantController',
            locals: {
              currentParticipant: data.result
            }
          });
        });
    }

    /** @public */
    function _openForm1095(recno, fchar){
      var method = '';
      var formName = '';
      if(fchar === 'X5B'){
        method = 'get1095BForms';
        formName = '1095B';
      }
      else{
        method = 'get1095CForms';
        formName = '1095C';
      }
      formService[method](recno).then(
        function(data){
          _showModal(data.result, formName);
        }, function(error){
          console.log('Error: ' + error);
        }
      );
    }

    /** @public */
    function _openEmployerInformationEdit(){
      _getEmployer(_this.employer.ptin).then(_complete);

      function _complete(){
        $scope.employerAction = 'edit';
        $scope.editDisabled = true;
        mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/employer/modals/form-employer.html',
          parent: angular.element(document.body),
          controller: 'EmployerController',
          locals: {
            currentEmployer: _this.employer
          }
        });
      }
    }

    /** @private */
    function _openEditFormC(){
      _getEmployer(_this.employer.ptin).then(_complete);

      function _complete(){
        mdDialog.show({
          scope: $scope.$new(),
          preserveScope: true,
          templateUrl: 'app/views/form/modals/form1094C.html',
          parent: angular.element(document.body),
          controller: 'Form1094CController',
          locals: {
            currentEmployer: _this.employer
          }
        });
      }
    }

    /** @private */
    function _getName(argument){
      return argument || '';
    }

    /** @public */
    function _back(argument){
      var params = $routeParams;
      if(params.section === CORRECTIONS_PAGE.RETRANSMIT_CORRECTED){
        $location.path('/send').search({section: 'send-check-list'});
      }
      else{
        _this.correctionsPage = CORRECTIONS_PAGE[argument];
      }
      _this.listPayers = [];
    }

    /** @public */
    function _backSend(){
      if(ManagedUserInformationService.isManagedServicesAndNotSovosProfile()){
        ManagedUserInformationService.checkManagedServices('aca');
      }
	  else{
		$location.path('/send').search('');
	  }
    }

    /** @public */
    function _goFamily(reportError){
      _this.currentEntity = reportError;
      var request = {
        fchar: (reportError.form === '1095-B') ? 'X5B' : 'X5C',
        accountno: reportError.accountno,
        ptin: reportError.payerid,
        tin: reportError.tin,
        xmitrun: _this.selectedXmitRun
      };
      correctionService.getFamilyInformationToCorrect(request).then(function(data){
        _this.family = data.result;
        _.map(_this.family, function(element){
          element.tinWithMask = participantService.maskTin(element.tin);
          element.tinWithoutSuffix = participantService.removeSuffixOnTin(element.tin);
        });
        _this.descriptionError = reportError.errorcd + ' - ' + reportError.errortxt;
        _this.correctionsPage = CORRECTIONS_PAGE.ERROR_PAYEE_FORM;
      }, function(error){
        console.log(error);
      });
    }

    /** @public */
    function _generateReport(xmitrun){
      reportService.generateXmitIRSResponse(xmitrun).then(function(data){
        if(data.result !== null){
          if(data.result.Status){
            _this.token = window.sessionStorage.token;
            _this.filename = 'REPORT~' + utilsService.splitFilename(data.result.FileName);
            _this.shortfilename = utilsService.splitFilename(_this.filename);

            _downloadReport();
          }
          else{
            _openErrorModal();
          }
        }
        else{
          _openErrorModal();
        }
      });
    }

    /** @public */
    function _markAsReady(entity){
      var request = {
        idsubmissionirs: _this.currentEntity.idsubmissionirs,
        recno: _this.currentEntity.wrecno,
        resubmit: (_this.currentEntity.ready_to_resubmit === 'Uncorrected') ? 'Y' : 'N'
      };
      correctionService.markAsReady(request).then(
        function(result){
          _this.errorReportByXmit(_this.selectedXmitRun);
        },
        function(error){
          console.log('Error: ' + error);
        }
      );
    }

    /** @private */
    function _openErrorModal(){
      mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/createReports/modals/message-report.html',
        parent: angular.element(document.body)
      });
    }

    /** @private */
    function _downloadReport(){
      var fileNameDate = utilsService.getUnixTimestamp(new Date()).split(' ');
      fileNameDate[0] = _this.shortfilename.replace('.xlsx', '_' + fileNameDate[0] + '.xlsx');
      http({
        method: 'POST',
        url: 'html/rfm/download.html',
        data: $.param({token: _this.token, rfm_filename: _this.filename, rfm_shortfilename: _this.shortfilename}),
        headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
        responseType: 'arraybuffer'
      }).success(function(data){
        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        if(utilsService.isInternetExplorer('11')){
          window.navigator.msSaveBlob(blob, fileNameDate[0]);
        }
        else{
          var objectUrl = URL.createObjectURL(blob);
          var anchor = angular.element('<a/>');
          anchor.css({display: 'none'});
          angular.element(document.body).append(anchor);
          anchor.attr({
            href: objectUrl,
            target: '_blank',
            download: fileNameDate[0]
          })[0].click();
          anchor.remove();
        }
      });
    }

    /** @private */
    function _showModal(form, formName){
      var statusForm = '';
      if(form.Forms1095C && form.Forms1095C.status === 'D'){
        statusForm = 'Dependent';
      }
      else{
        if(form.Forms1095B && form.Forms1095B.status === 'D'){
          statusForm = 'Dependent';
        }
      }
      var params = {
        subscriber: undefined,
        currentForm: form
      };
      mdDialog.show({
        scope: $scope.$new(),
        controller: 'Form' + statusForm + 'Controller',
        templateUrl: 'app/views/form/modals/form' + formName + statusForm + '.html',
        preserveScope: true,
        locals: params
      });
    }

    /** @public */
    function _getTinMask(tin){
      if(!tin && typeof tin === 'string') return;

      return '*****' + tin.substring(5, 9);
    }

    /** @public */
    function _retrasmitCorrected(){
      var data = {};
      data.result = [];
      _this.retransmit = {step: 1};
      if(_this.comesCheckList){
        _this.correctionsPage = CORRECTIONS_PAGE.RETRANSMIT_CORRECTED;
      }
      else{
        var listOfEmployer = (_this.errorReportsEmployers.length > 0) ? _this.errorReportsEmployers : _this.errorReportSubscribers;
        data.result = _.map(listOfEmployer, function(element){
          if(element.corrected !== undefined && (element.corrected === 'C' || element.corrected === 'CP') && element.xmitrun === undefined && element.form !== 'PAYER'){
            if(!_checkIfExistsPayer(element.payerid)){
              return {'payerid': element.payerid, 'pname': (element.pname !== undefined) ? element.pname : ''};
            }
          }
        }).filter(Boolean);
        _setEmployerData(data);
      }
    }

    /** @pivate */
    function _checkIfExistsPayer(payerid){
      var exists = false;
      if(_this.listPayers.length > 0){
        if(_.indexOf(_this.listPayers, payerid) === -1){
          _this.listPayers.push(payerid);
        }
        else{
          exists = true;
        }
      }
      else{
        _this.listPayers.push(payerid);
      }
      return exists;
    }

    /** @private */
    function _setEmployerData(data){
      if(data.result.length > 0){
        _this.employers = data.result;
        _this.correctionsPage = CORRECTIONS_PAGE.RETRANSMIT_CORRECTED;
      }
      else{
        mdDialog.show({
          scope: $scope.$new(),
          templateUrl: 'app/views/corrections/modals/message-correction-not-data.html',
          parent: angular.element(document.body),
          controller: 'DialogController'
        });
      }
    }

    /** @public */
    function _retransmitConfirmation(){
      var rpcTransmittalRequest = _setTransmittalConfig(OUTPUT_TYPE.TRANSMITTAL);
      if(rpcTransmittalRequest === true){
        return true;
      }
      _executeTransmittal('app/views/corrections/modals/correction-processing-transmittal.html', rpcTransmittalRequest);
    }

    /** @public */
    function _retransmitConfirmationDocGen(){
      var rpcTransmittalRequest = _setTransmittalConfig(OUTPUT_TYPE.TRANSMITTAL);
      if(rpcTransmittalRequest === true){
        return true;
      }
      _executeTransmittalDocGen('app/views/corrections/modals/correction-processing-transmittal.html', rpcTransmittalRequest);
    }

    /** @public */
    function _sendReXmit(transmittalFileName, xmitRun){
      mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/corrections/modals/send-transmittal.html',
        parent: angular.element(document.body)
      });
      var xmitRequest = {
        FileName: transmittalFileName.toString(),
        XmitRun: xmitRun.toString(),
        JobId: $scope.jobId || 0,
        Hash: $scope.hash || '',
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: utilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL)
      };
      sendService.SendXmit(xmitRequest).then(function(data){
        var validStatus = data.result.Xmit.StatusInt === XMIT_STATUS.QUEUED ||
          data.result.Xmit.StatusInt === XMIT_STATUS.IRS_PROCESSING ||
          data.result.Xmit.StatusInt === XMIT_STATUS.COMPLETE ||
          data.result.Xmit.StatusInt === XMIT_STATUS.QUEUED_FOR_SUBMISSION;
        if(validStatus){
          mdDialog.hide();
          _this.correctionsPage = CORRECTIONS_PAGE.XMIT_SUCCESS;
          _this.retransmit.step = 3;
          _this.outputType = 'aca';
        }
        else{
          mdDialog.hide();
          _this.correctionsPage = CORRECTIONS_PAGE.XMIT_ERROR;
          _this.retransmit.step = 3;
          _this.outputType = 'aca';
        }
      });
    }

    /** @public */
    function _cancelTransmitCorrected(xmitRun){
      mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/corrections/modals/cancel-transmittal.html',
        parent: angular.element(document.body)
      });
      CommonTransmittalService.cancelTransmittal(xmitRun, _this);
    }

    /** @private */
    function _requiredOptionIsMissing(){
      _this.employersSelected = _this.employers.some(function(e){
        return !!e.selected;
      });
      _this.formsSelected = (_this.form.selected !== undefined);

      if(!_this.formsSelected){
        _this.errorMessage = CORRECTIONS_PAGE.NOFORMSSELECTED;
      }
      if(!_this.employersSelected){
        _this.errorMessage = CORRECTIONS_PAGE.NOPAYERSSELECTED;
      }

      return (_this.formsSelected && _this.employersSelected);
    }

    $rootScope.$watch('isRefresh', function(){
      switch($rootScope.isRefresh){
        case 'updateParticipant':
          _this.goFamily(_this.currentEntity);
          $rootScope.isRefresh = '';
          break;
      }
    });

    /** @public */
    function _setReviewStatusOnReport(value, errorReport){
      correctionService.setReviewStatusOnReport(errorReport.xmitrun, value).then(function(){
        errorReport.status = (value === 'Y')
          ? 'REVIEWED'
          : 'UNREVIEWED';
      });
    }

    /** @public */
    function _generateTransmittal(){
      _this.correctionsPage = CORRECTIONS_PAGE.CORRECTIONS;
    }

    /** @public */
    function _checkProfileToShow(){
      return !ManagedUserInformationService.isManagedServicesAndNotSovosProfile();
    }

    /** @public */
    function _isManagedServices(){
      return ManagedUserInformationService.isManagedServices();
    }

    /** @private */
    function _setTransmittalConfig(outputType){
      if(_requiredOptionIsMissing()){
        _this.errorMessage = '';
        return _getRpcRequest(outputType);
      }
      return true;
    }

    /** @private */
    function _getRpcRequest(outputType){
      return {
        Fchar: _this.form.selected,
        Payers: _getPayerSelected(),
        Output: outputType,
        FilingStatus: 'Correction',
        TransmittalType: 'Accepted & Accepted With Errors'
      };
    }

    /** @private */
    function _getPayerSelected(){
      var payers = '';
      _this.employers.forEach(function(e){
        if(e.selected !== undefined){
          payers += e.selected + ',';
        }
      });
      payers = payers.replace(/'/g, '');
      return payers.slice(0, -1);
    }

    /** @private */
    function _executeTransmittal(url, rpcTransmittalRequest){
      sendService.callXmit(rpcTransmittalRequest).then(
        function(data){
          $scope.jobId = data.result.DataInt;
          $scope.type = LRJ_MANAGER.JOBTYPE.XMIT;
          mdDialog.show({
            scope: $scope.$new(),
            templateUrl: url,
            parent: angular.element(document.body)
          });
        },
        function(error){
          mdDialog.hide().finally(function(){
            _showMessageFromSend(error);
          });
        }
      );
    }

    /** @private */
    function _executeTransmittalDocGen(url, rpcTransmittalRequest){
      sendService.generateDocgenFederalXmit(rpcTransmittalRequest).then(
        function(data){
          if(data.result.value){
            $rootScope.outputType = OUTPUT_TYPE.TRANSMITTAL;
            $location.path('/send').search({section: 'send-transmittal-generated'});
          }else{
            $scope.corrCont.correctionsPage = 'correction-failed';
          }
        },
        function(error){
          _finishServiceJob(renewToken);
          mdDialog.hide().finally(function(){
            _showMessageFromSend(error);
          });
        }
      );
    }

    $rootScope.$on('FINISH_XMIT', function(event, data){
      if(data !== undefined){
        var filesXmitRun = [];
        var xmitRunIds = [];
        var counts = [];
        var progress = [];
        var idXmitrun = [];

        var progressList = data.filter(function(e){
          return e.match(/Id\: /);
        });
        _.each(progressList, function(p){
          getFileNameWithXmitrun(p);
          progress.push(
            p.split('\n').filter(function(e){
              return !e.match(/^Xmit Payers - Lrj\: /);
            })
          );
        });
        _.each(progress, function(pr){
          idXmitrun.push(
            pr.filter(function(e){
              return e.match(/^Id\: /);
            })
          );
        });
        _.each(progress, function(p){
          p.filter(function(e){
            filesXmitRun.push(e.match(/^FileName\: /));
          });
        });
        _.each(idXmitrun, function(xm){
          xm.forEach(function(e){
            xmitRunIds.push(
              utilsService.getXmitRunIds(e)
            );
          });
        });
        _this.xmitRun = xmitRunIds.toString();
        (xmitRunIds.length > 1) ? _this.outputType = OUTPUT_TYPE.TRANSMITTALSPLIT.toLowerCase() : _this.outputType = OUTPUT_TYPE.TRANSMITTAL.toLowerCase();
        sendService.GetEmployerInfoInTransmittal(xmitRunIds.toString()).then(function(response){
          _this.employerRecords.splice(0, _this.employerRecords.length);
          response.result.RecordsEmployer.forEach(function(element){
            mdDialog.hide();
            counts[element.StmtRun] = (counts[element.StmtRun]||0)+1;
            element.countRows = counts[element.StmtRun];
            element.filename = _this.filesWithXmitrun[element.StmtRun];
            _this.FileParts = utilsService.splitFilenameXmit(String(element.filename));
            element.showfilename = _this.FileParts[2] + '~' + _this.FileParts[3];
            element.filename = _this.FileParts[1] + '~' + element.showfilename;
            if(!_.contains(_this.filesNames, element.showfilename)){
              _this.filesNames.push(element.showfilename);
            }
            _this.employerRecords.push(element);
          });
          orderByXmitRunAndRowSpan();
          _this.token = $window.sessionStorage.token;
          _this.retransmit.step = 2;
        },
        function(error){
          mdDialog.hide();
          console.log(error);
        });
      }
    });

    var orderByXmitRunAndRowSpan = function(){
      _this.employerRecords.sort(function(a, b){
        var aXmitRun = a.StmtRun;
        var bXmitRun = b.StmtRun;
        var aRowSpan = a.countRows;
        var bRowSpan = b.countRows;
        if(aXmitRun === bXmitRun){
          return (aRowSpan > bRowSpan) ? -1 : (aRowSpan < bRowSpan) ? 1 : 0;
        }
        else{
          return (aXmitRun < bXmitRun) ? -1 : 1;
        }
      });
    };

    var getFileNameWithXmitrun = function(data){
      var idx = data.replace(/\n/g, ' ').match(/(?:Id:)(.+)(?:FileName:)/)[1].trim();
      var value = data.replace(/\n/g, ' ').match(/(?:FileName:)(.*)/)[1].trim();
      _this.filesWithXmitrun[idx] = value;
    };

    $rootScope.$on('FINISH_XMIT_ERROR', function(event, data){
      var progressList = data
        .filter(function(e){
          return e.match(/ Error\: /);
        })
        .map(function(e){
          return e.split(' Error: ')[1];
        });

      var configuration = {
        titleMessage: ERROR.TRANSMITTAL.ERRORTITLE,
        actionMessage: ERROR.TRANSMITTAL.ERRORSUBMITTRANSMITTAL,
        supportAssistance: '',
        button: 'Back to Send Options'
      };
      errorOnTransmittal(progressList[0], configuration);
    });

    var errorOnTransmittal = function(error, configuration){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      mdDialog.hide().finally(function(){
        $scope.sendOptionFile = 'transmittal';
        _showMessageError(error, configuration);
      });
    };

    /** @private */
    function _finishServiceJob(renewToken){
      _this.jobProcessing = false;
      $interval.cancel(renewToken);
      mdDialog.hide();
    }

    /** @private */
    function _showMessageError(error, configuration){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      if(error !== '' && error !== undefined){
        _this.errorMessageXmit = error;
      }
      else{
        _this.errorMessageXmit = 'System Error';
        configuration.supportAssistance = ERROR.TRANSMITTAL.SUPPORTASSIST;
      }
      configuration.errorMessage = _this.errorMessageXmit;
      $scope.corrCont.configuration = configuration;
      $scope.corrCont.correctionsPage = ERROR.ERRORAPAGE;
    }

    /** @private */
    function _showMessageFromSend(error){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      if(error.data.error.frontend_message !== '' && error.data.error.frontend_message !== undefined){
        _this.errorMessage = error.data.error.frontend_message;
      }
      else{
        _this.errorMessage = 'System Error';
      }
      _this.correctionsPage = CORRECTIONS_PAGE.CORRECTIONS;
    }

    function _closeModal(){
      ShortcutsService.enableBackSpaceDefault();
      mdDialog.hide();
    }

    function _goToCorrectionPage(){
      mdDialog.hide();
      $location.path('/send').search({section: CORRECTIONS_PAGE.XMIT_STATUS});
    }

    function _goSend(){
      $location.search({});
      $location.path('/send');
      $route.reload();
    }

    function _showEmailAddress(){
      sendService.getManagedServicesEmailList().then(function(data){
        var dataEmail = {
          listEmails: data.result,
          CodeTypeRun: _this.xmitRun,
          FileName: _this.filesNames.toString(),
          Fchar: _this.form.selected,
          JobId: $scope.jobId || 0,
          TypeFile: SETTINGS.TRANSMITTAL,
          TypeTitle: utilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL),
          OutputType: _this.outputType
        };
        mdDialog.show({
          scope: $scope,
          templateUrl: 'app/views/send/modals/send-email-to-approve.html',
          parent: angular.element(document.body),
          preserveScope: true,
          controller: 'SendEmailController as seCont',
          locals: {
            dataEmail: dataEmail
          }
        });
      });
    }
  }
})();